import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { recurrentApplicationsDelete } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteRecurrentApplication = (
  publisherId: number,
  options: UseMutationOptions<void, unknown, number, unknown> = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (applicationId) =>
      extractData(
        recurrentApplicationsDelete({
          path: { publisherId, applicationId },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['recurrentApplications'] });
      options.onSuccess?.(...args);
    },
  });
};
